import { ChartColumnIcon } from 'lucide-react';
import { FC } from 'react';
import { MIN_CHART_HEIGHT_STYLE } from '../DashboardPresetGrid/chartLayout';

/**
 * Место будущей диаграммы: пока описание не истолковано, показывать нечего, но место, куда
 * диаграмма встанет, пользователь видит с самого начала — блок её свойств развёрнут под ним.
 */
export const NewChartPlaceholder: FC = () => (
  <div
    style={MIN_CHART_HEIGHT_STYLE}
    className="grid place-items-center rounded-xl border-2 border-dashed text-muted-foreground"
  >
    <ChartColumnIcon className="size-6" />
  </div>
);
